import { getOriginalResource } from "PFApp/booking/parts/helpers";
import { Row, RowType } from "PFApp/booking/types";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { ProfileBasic } from "PFApp/booking/types/row";
import { isProjects } from "PFApp/booking/utils/calendar_root.utils";
import { ProjectItem } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";

type GetActivityItemsForActivityWarnings = {
  rows: Row[];
  calendarRoot: CalendarRoot;
  isRoleLevelHiddenForEngagementsRoot: boolean;
};

export const getActivityItemsForActivityWarnings = ({
  rows,
  calendarRoot,
  isRoleLevelHiddenForEngagementsRoot
}: GetActivityItemsForActivityWarnings): { rowKey?: string; id: number }[] => {
  if (!isProjects(calendarRoot)) {
    return [];
  }
  if (isRoleLevelHiddenForEngagementsRoot) {
    return rows
      .filter(({ type }) => type === RowType.Profile)
      .flatMap((row) => {
        const { activityIds } = getOriginalResource(row, calendarRoot) as ProfileBasic;
        return activityIds ?? [];
      })
      .map((id) => ({ id }));
  } else {
    return rows
      .filter(({ type }) => type === RowType.Role)
      .map(({ key, original }) => ({ rowKey: key, id: (original as ProjectItem).id }));
  }
};
